import React from 'react'
import { AiOutlineComment } from 'react-icons/ai';

const CommentIcon = ({onClick, fontSize=25 }) => {
  return (
    <button className="round-red-button" style={{backgroundColor:"darkblue", marginLeft:"10px", width:"110px", borderRadius:"30px"}} onClick={onClick} type="button">
    <AiOutlineComment 
    fontSize={fontSize}
    color={"white"} />
    <h3 style={{color:"white"}}>POSTA</h3>
</button>
  )
}

export default CommentIcon
